import state from './modulePaypingState.js'
import mutations from './modulePaypingMutations.js'
import actions from './modulePaypingActions.js'
import getters from './modulePaypingGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
